
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useOptimizedStats = () => {
  return useQuery({
    queryKey: ["optimized-stats"],
    queryFn: async () => {

      // استخدام دالة Supabase لجلب الإحصائيات المحسّنة
      const { data, error } = await supabase.rpc('get_dashboard_stats');
      
      if (error) {
        console.error('Error fetching dashboard stats:', error);
        throw error;
      }

      return data || {
        employees: { total: 0, present: 0, absent: 0, late: 0, departments: 0 },
        clients: { total: 0, by_status: {} },
        bookings: { total: 0, this_month: 0, total_revenue: 0 },
        tasks: { total: 0, pending: 0, in_progress: 0, overdue: 0 },
        hotels: { total: 0, countries: 0, cities: 0, average_stars: 0 }
      };
    },
    staleTime: 5 * 60 * 1000, // 5 دقائق
    gcTime: 10 * 60 * 1000, // 10 دقائق
    refetchOnWindowFocus: false,
  });
};
